import {get, post, put} from './config';

const Employee = {
    getByEmployees: (companyId, page = 1, limit = 15) =>
        get(`v1/users/employee?companyId=${companyId}&page=${page}&limit=${limit}`),
    createEmployee: (data) =>
        post(`v1/users/employee`, data),
    getEmailByEmployee: (code) =>
        get(`v1/users/get-user-email/${code}`),
    setEmployeePassword: (data) =>
        post(`v1/users/employee/invitation/accept`, data),
    getEmployee: (employeeId) =>
        get(`v1/users/employee/by-${employeeId}`),
    editEmployee: (employeeId, data) =>
        put(`v1/users/employee/${employeeId}`, data)
}

export default Employee;
